<template>
  <div class="delete-employee" />
</template>

<script>
export default {
  name: 'Delete',
  mounted() {
    this.$buefy.dialog.confirm({
      title: 'Borrar empleado',
      message: '¿Estas seguro de borrar este empleado?',
      confirmText: 'Borrar',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: () => {
        this.$store.dispatch('employees/deleteSingle', this.$route.params.employee).then(() => {
          this.$success({ message: 'El empleado se eliminó correctamente' });
        }).catch(() => {
          this.$danger({ message: 'Ocurrió un error al momento de borrar' });
        });
        this.$router.push({ name: 'Employees', query: { page: 1, size: 20 } });
      },
      onCancel: () => {
        this.$router.push({ name: 'Employees', query: { page: 1, size: 20 } });
      },
    });
  },
};
</script>

<style scoped>
</style>
